import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

export default function Subscriptions() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Subscriptions'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
}
